// Self-contained data for the Agencia Belen Pawnshop & Jewelry concept website.
export const BIZ = {
  name: "Agencia Belen Pawnshop & Jewelry",
  brand: "AGENCIA BELEN",
  sub: "Pawnshop & Jewelry — Dumaguete",
  tagline: '"Ang Karaang Kasaligan sa Dumaguete!" — The Old Trusted One',
  intro:
    "We're Agencia Belen, a long-running Dumaguete pawnshop and jewelry store on Perdices St. We offer jewelry sales, appraisals and pawnshop services, and we stand behind our Highest Appraisals promise.",
  address: "Perdices St., Dumaguete City, Negros Oriental",
  phone: "+63 35 523 5613",
  rating: "4.6",
  reviewCount: 21,
  facebook: "https://www.facebook.com/PawnHere6200/",
  mapEmbed: "https://www.google.com/maps?q=Perdices+St+Dumaguete+City+Negros+Oriental&output=embed",
};

export const SERVICES = [
  { cat: "pawnshop", title: "Pawnshop Services", text: "We offer loans against jewelry and valuables, with appraisals done in-store." },
  { cat: "jewelry", title: "Jewelry Sales", text: "Gold jewelry, diamond pieces and wedding bands for everyday and special occasions." },
  { cat: "pawnshop", title: "Highest Appraisals", text: "We aim to give you the highest appraisal value for your pawned items." },
  { cat: "pawnshop", title: "Rematado Promotions", text: "We occasionally hold rematado (unredeemed pawn) sales — watch our page." },
];

export const PRODUCTS = [
  { name: "Diamond Engagement & Wedding Set", desc: "Classic white-gold trio: engagement solitaire with two matching bands.", img: "/agenciabelen/prod-gold-bands.jpg" },
  { name: "Tissot Le Locle Powermatic 80", desc: "Swiss automatic watch — an example of branded pieces handled in-store.", img: "/agenciabelen/prod-tissot.jpg" },
  { name: "Oris Automatic, 25 Jewels", desc: "Vintage-style Swiss automatic watch, gold-tone case.", img: "/agenciabelen/prod-oris.jpg" },
  { name: "Branded Watch Selection", desc: "A mix of ladies' and men's branded watches available in-store.", img: "/agenciabelen/prod-watches-mixed.jpg" },
];

export const STEPS_PAWN = [
  { n: "1", title: "Bring Item", text: "Bring jewelry, watches or other valuables in for appraisal." },
  { n: "2", title: "Get Appraised", text: "We assess and quote you our Highest Appraisal value." },
  { n: "3", title: "Confirm Terms", text: "Agree on loan amount and redemption terms before proceeding." },
  { n: "4", title: "Redeem or Renew", text: "Return to redeem your item, or renew per our policy." },
];

export const STEPS_JEWELRY = [
  { n: "1", title: "Browse", text: "View our wedding rings, diamond pieces and everyday jewelry in-store or on Facebook." },
  { n: "2", title: "Ask", text: "Message us or call to ask about a specific piece or price." },
  { n: "3", title: "Confirm", text: "We'll confirm purity, price and availability before you decide." },
  { n: "4", title: "Buy", text: "Complete your purchase in-store at Perdices St., Dumaguete City." },
];
